<div class="program-progress-section" data-testid="completion-progress">
  <div class="program-progress">
    <div class="program-progress-info-content">
      <div class="program-progress-title">
        <span class="program-progress-label">{{ 'translations.completion' | transloco }}</span>
        <span class="program-progress-value" data-testid="completion-progress-count" *ngIf="goal()?.progressCounter?.counter === 'NUMBER'">
          {{ goal().completedCards }}/{{ goal().totalCards }}
        </span>
        <span
          class="program-progress-value"
          data-testid="completion-progress-count"
          *ngIf="goal()?.progressCounter?.counter === 'PERCENTAGE'"
        >
          {{ goalCompletedPercentage() }}%
        </span>
      </div>
      <div class="program-goal-card-number-progress-container">
        <div class="program-goal-card-number-progress-box">
          <div class="program-goal-card-number-progress">
            <span
              class="program-goal-card-number-progress-value"
              [style.background-color]="goal()?.color"
              [style.width]="goalCompletedPercentage() + '%'"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
